import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { useNavigate } from "react-router";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import {
  CreatePromoForm,
  CreatePromoFormValues,
  mapBonusToPayload,
} from "./CreatePromoForm.tsx";
import { mapValidityToPayload } from "../../UI/Utils/validityDays.ts";
import { useCreatePromo } from "../../ProductService/NormasTeachingPromo/useCreatePromo.ts";
import { AdminAllPromosScreenPath } from "./AdminAllPromosScreen.tsx";
import { useAllNormasTeachingProducts } from "../../ProductService/NormasTeachingProduct/useAllNormasTeachingProducts.ts";

export function CreatePromoScreen() {
  const { products, isLoading } = useAllNormasTeachingProducts();
  const { createPromo, loading: saving } = useCreatePromo();
  const navigate = useNavigate();

  const onSubmit = async (data: CreatePromoFormValues): Promise<void> => {
    await createPromo({
      name: data.name,
      description: data.description,
      bonuses: data.bonuses.map(mapBonusToPayload),
      ...mapValidityToPayload(data),
      applicableProducts: data.applicableProducts,
    });
    navigate(AdminAllPromosScreenPath);
  };

  if (isLoading) return <FullPageLoading />;

  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className="p-4 flex-1 flex items-center">
          <div className="max-w-[1024px] w-full mx-auto bg-white p-4 rounded-lg flex flex-col gap-4">
            <h1 className="font-bold text-2xl">Crea Promo</h1>
            <CreatePromoForm
              onSubmit={onSubmit}
              saving={saving}
              products={products}
            />
          </div>
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
